import { motion } from "framer-motion";
import { fadeInUp, staggerContainer } from "@/components/motionVariants";

const packages = [
  {
    id: "15",
    label: "15 นาที",
    price: "89 บาท",
    detail: "เหมาะสำหรับคำถามเร่งด่วน",
  },
  {
    id: "30",
    label: "30 นาที",
    price: "139 บาท",
    detail: "ยอดนิยม — เวลาเพียงพอสำหรับความชัดเจน",
    highlight: true,
  },
  {
    id: "60",
    label: "60 นาที",
    price: "229 บาท",
    detail: "เจาะลึกทั้งหัวใจและเส้นทางอนาคต",
  },
];

export const PricingSection = ({ lineUrl }) => {
  return (
    <motion.section
      id="pricing"
      className="py-16 md:py-24"
      data-testid="pricing-section"
      {...fadeInUp}
    >
      <div className="mx-auto max-w-md px-6 md:max-w-4xl md:px-12 lg:max-w-6xl">
        <motion.h2
          {...fadeInUp}
          className="font-serif text-3xl text-taupe md:text-4xl"
          data-testid="pricing-title"
        >
          แพ็กเกจการดูแลหัวใจ
        </motion.h2>
        <motion.p
          {...fadeInUp}
          className="mt-4 text-base text-taupeLight"
          data-testid="pricing-subtitle"
        >
          เลือกเวลาที่เหมาะกับคุณ พร้อมความใส่ใจแบบพรีเมียมในทุกนาที
        </motion.p>
        {/*
        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.2 }}
          className="mt-10 grid gap-6 md:grid-cols-3"
          data-testid="pricing-grid"
        >
          {packages.map((pkg) => (
            <motion.div
              key={pkg.id}
              variants={fadeInUp}
              className={`flex h-full flex-col rounded-2xl border px-6 py-8 shadow-soft transition-transform duration-300 hover:-translate-y-1 ${
                pkg.highlight
                  ? "border-gold bg-taupe text-white"
                  : "border-rose/30 bg-white text-taupe"
              }`}
              data-testid={`pricing-card-${pkg.id}`}
            >
              {pkg.highlight && (
                <span
                  className="mb-4 inline-flex w-fit rounded-full bg-gold px-3 py-1 text-xs font-semibold text-taupe"
                  data-testid="pricing-badge-popular"
                >
                  ยอดนิยม
                </span>
              )}
              <h3
                className={`text-xl font-semibold ${pkg.highlight ? "text-white" : "text-taupe"}`}
                data-testid={`pricing-card-title-${pkg.id}`}
              >
                {pkg.label}
              </h3>
              <p
                className={`mt-2 text-3xl font-semibold ${pkg.highlight ? "text-white" : "text-taupe"}`}
                data-testid={`pricing-card-price-${pkg.id}`}
              >
                {pkg.price}
              </p>
              <p
                className={`mt-3 text-sm ${pkg.highlight ? "text-white/80" : "text-taupeLight"}`}
                data-testid={`pricing-card-detail-${pkg.id}`}
              >
                {pkg.detail}
              </p>
              <a
                href={lineUrl}
                target="_blank"
                rel="noreferrer"
                className={`mt-6 inline-flex items-center justify-center rounded-full px-4 py-2 text-sm font-semibold transition-colors duration-300 ${
                  pkg.highlight
                    ? "bg-white text-taupe hover:bg-cream"
                    : "border border-line/40 text-line hover:bg-line hover:text-white"
                }`}
                data-testid={`pricing-card-cta-${pkg.id}`}
                aria-label={`จองผ่าน LINE แพ็กเกจ ${pkg.label}`}
              >
                จองผ่าน LINE
              </a>
            </motion.div>
          ))}
        </motion.div> */}
        <motion.div
          {...fadeInUp}
          className="mt-10 flex justify-center"
        >
          <img
            src="images/promo-sai.jpg"
            alt="Promotion"
            className="w-full max-w-md md:max-w-lg lg:max-w-xl h-auto rounded-2xl shadow-soft"
          />
        </motion.div>
      </div>
    </motion.section>
  );
};